// API Configuration
export const API_CONFIG = {
  // These will be replaced during deployment with actual values
  REST_API_URL: process.env.REACT_APP_REST_API_URL || 'http://localhost:3001',
  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:3001',
  COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
  COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
  COGNITO_DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || '',
  COGNITO_REDIRECT_SIGN_IN: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || 'http://localhost:3000/',
  COGNITO_REDIRECT_SIGN_OUT: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || 'http://localhost:3000/',
  REGION: process.env.REACT_APP_REGION || 'us-west-2',
};

// Test Scenarios
export const TEST_SCENARIOS = [
  {
    id: 1,
    name: 'Live Trend Analysis',
    slug: 'trends',
    prompt: "what's the latest news right now? give me the funniest take",
    description: 'Test real-time information retrieval and humor generation',
    webSearchDefault: true,
  },
  {
    id: 2,
    name: 'Hard Math',
    slug: 'math',
    prompt: 'find all integer solutions to x^3+y^3+z^3=3xyz+2026',
    description: 'Test mathematical problem-solving capabilities',
    webSearchDefault: false,
  },
  {
    id: 3,
    name: 'Humor Blind Test',
    slug: 'humor',
    prompt: "Roast me like I'm Elon Musk trying to sell a Cybertruck to a vegan",
    description: 'Test humor and creative writing abilities',
    webSearchDefault: false,
  },
  {
    id: 4,
    name: 'Real-time News vs Stale',
    slug: 'news',
    prompt: "What's the latest on [topic]?",
    description: 'Compare real-time vs outdated information',
    webSearchDefault: true,
  },
  {
    id: 5,
    name: 'Race Test',
    slug: 'race',
    prompt: 'Explain quantum computing in simple terms',
    description: 'Measure speed and quality of responses',
    webSearchDefault: false,
  },
  {
    id: 6,
    name: 'Chain-of-thought Showdown',
    slug: 'reasoning',
    prompt: 'You have nine coins, one fake lighter - find it in two weighings',
    description: 'Test logical reasoning and problem-solving',
    webSearchDefault: false,
  },
];
